import { Controller } from '@hotwired/stimulus';

// Screen readers should not hear a count on every keystroke, so announcements are
// debounced and only made once the user is close to the limit.
const ANNOUNCE_DELAY = 1000;
const ANNOUNCE_FROM_FRACTION = 0.1;

export default class extends Controller {
  static targets = ['field', 'count', 'announcement'];
  static values = { max: Number };

  connect() {
    this.render();
  }

  disconnect() {
    window.clearTimeout(this.announceTimeout);
  }

  update() {
    this.render();
    window.clearTimeout(this.announceTimeout);
    this.announceTimeout = window.setTimeout(() => this.announce(), ANNOUNCE_DELAY);
  }

  render() {
    this.countTarget.textContent = this.summary;
    this.countTarget.classList.toggle('font-semibold', this.remaining === 0);
  }

  announce() {
    const nearLimit = this.remaining <= this.maxValue * ANNOUNCE_FROM_FRACTION;
    this.announcementTarget.textContent = nearLimit ? this.summary : '';
  }

  get remaining(): number {
    return this.maxValue - this.fieldTarget.value.length;
  }

  get summary(): string {
    if (this.remaining === 0) return 'No characters remaining';

    return `${this.remaining} character${this.remaining === 1 ? '' : 's'} remaining`;
  }

  declare fieldTarget: HTMLTextAreaElement;
  declare countTarget: HTMLElement;
  declare announcementTarget: HTMLElement;
  declare maxValue: number;
  declare announceTimeout: number;
}
